// extracted by mini-css-extract-plugin
export default {"body":"PatientImportDialog_body__9UGf2"};